import React from "react";

export default class HowvideoDemolition extends React.Component  
{
    render()
    {
        return (
            <div class="block howvideo services mb-5">               
                <div className="card">  
                    <h3>How It Works</h3> 
                    <p>Learn how Hometown Demolition connects you with new demolition customers.</p>
                    <iframe src="https://www.youtube-nocookie.com/embed/BRIvL1mjRxU" width="560" height="315" frameborder="0" loading="lazy"></iframe>
                    <a className="btn btn-primary" href="/pro/guide/leads-demolition-how-it-works-video">Watch Tutorial</a>
                </div>
            </div>
        )
    }
};